import styled, { css } from 'styled-components';

const rightMask = css`
  right: 0;
`;

const leftMask = css`
  left: 0;
`;

export const OpacityMask = styled.div<{ side: string }>`
  background: ${({ side }) =>
    `linear-gradient(to ${
      side === 'left' ? 'right' : 'left'
    }, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, .4) 80%);`};
  height: 100%;
  width: 11%;
  position: absolute;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.opacityMask};
  ${({ side }) => (side === 'right' ? rightMask : leftMask)}
`;
